import { Component } from '@stencil/core';

/** @internal **/
@Component({ tag: 'test-component' })
export class TestComponent {}
